/**
 * class for decoding errors
 *
 * @extends {Error}
 */
class TCModelError extends Error {
  /**
   * constructor - constructs an TCModelError
   *
   * @param {string} fieldName - the errored field
   * @param {string} passedValue - what was passed
   * @return {undefined}
   */
  constructor(fieldName, passedValue) {
    let msg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    super("invalid value ".concat(passedValue, " passed for ").concat(fieldName, " ").concat(msg));
    this.name = 'TCModelError';
  }
}
export { TCModelError };